module.exports = __webpack_public_path__ + "img/charisma@2x.d45b49b.webp";